const CurrentLocation = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="icons">
                <circle id="Ellipse 615" cx="12" cy="12" r="8" stroke="black" />
                <circle
                    id="Ellipse 616"
                    cx="12"
                    cy="12"
                    r="1"
                    fill="black"
                    stroke="black"
                />
                <line
                    id="Line 30"
                    x1="17"
                    y1="12"
                    x2="23"
                    y2="12"
                    stroke="black"
                />
                <line
                    id="Line 32"
                    x1="12"
                    y1="7"
                    x2="12"
                    y2="1"
                    stroke="black"
                />
                <line
                    id="Line 31"
                    x1="1"
                    y1="12"
                    x2="7"
                    y2="12"
                    stroke="black"
                />
                <line
                    id="Line 33"
                    x1="12"
                    y1="23"
                    x2="12"
                    y2="17"
                    stroke="black"
                />
            </g>
        </svg>
    )
}

export default CurrentLocation
